import PropTypes from 'prop-types';
import React, { useState } from 'react';

export default function TierItemForm({ name, tierKey, tiers, onChange }) {
  const [display, setDisplay] = useState(false);
  return (
    <>
      <div
        className="flex flex-row gap-3 items-center mt-4 cursor-pointer select-none"
        onClick={() => setDisplay(!display)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        <h4 className="font-bold">{name}</h4>
        {/* <Switch

          checked={display}
          onChange={() => setDisplay(!display)}
          className={`${display ? 'bg-main' : 'bg-gray-200'}
          relative inline-flex flex-shrink-0 w-10 h-5 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
        >
          <span className="sr-only"></span>
          <span
            aria-hidden="true"
            className={`${display ? 'translate-x-5' : 'translate-x-0'}
            pointer-events-none inline-block w-4 h-4 rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200`}
          />
        </Switch> */}
      </div>
      {display && (
        <div className="mt-3 grid grid-cols-2 gap-3">
          {tiers.map((x, idx) => {
            return (
              <label key={idx.toString()} className="block text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  {idx === 7 ? (
                    <>Bonus Poin </>
                  ) : (
                    <>
                      Hari ke {`${idx + 1}`}&nbsp;
                      <span className="text-red-500">*</span>
                    </>
                  )}
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="0"
                  name={`${idx}`}
                  value={x}
                  // type="number"
                  onChange={(e) => {
                    onChange(e, tierKey);
                  }}
                />
              </label>
            );
          })}
        </div>
      )}
    </>
  );
}

TierItemForm.propTypes = {
  name: PropTypes.string.isRequired,
  tiers: PropTypes.array.isRequired,
  tierKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
